/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {ringBuilderStore} from 'extensions/ring-builder/data/ring-builder-store';
import {defineCustomElement} from 'extensions/utils';
import {LitElement, html} from 'lit';
import {observable, computed, makeObservable} from 'mobx';

class ProductPageProductName extends MobxReactionUpdate(LitElement) {

	constructor () {
		super();

		this._productName = '';

		makeObservable(this, {
			_productName: observable,
			productName: computed
		});
	}

	async firstUpdated () {
		this.store = await ringBuilderStore;
	}

	handleSlotChange (e) {
		const childNodes = e.target.assignedNodes({flatten: true});

		// Get product name from text content
		this._productName = childNodes.map((node) => {
			return node.textContent ? node.textContent : '';
		}).join('');
	}

	get productName () {
		return this.store?.loaded
			? `${this._productName} with ${parseFloat(this.store?.diamond?.product?.attributes?.carat).toFixed(2)}ct ${this.store?.diamond?.product?.attributes?.shape} Diamond`
			: this._productName;
	}

	render () {
		return html`
			<span>${this.productName}</span>
			<slot hidden @slotchange="${this.handleSlotChange}"></slot>
		`;
	}

};

defineCustomElement('rb-product-page-product-name', ProductPageProductName);
